import { render, staticRenderFns } from "./SelectionStallion.vue?vue&type=template&id=1d5abdfa&"
import script from "./SelectionStallion.vue?vue&type=script&lang=js&"
export * from "./SelectionStallion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports